export const AppRoutes = Object.freeze({
  PRE_ORDER_ITEMS: "/pre-order-items/:productId",
  SUPPLIERS: "/suppliers/:supplierId",
  PRE_ORDERS: "/pre-orders/:orderId",
  CATALOG: "/catalog/:productId",
  PRODUCT: "/product/:productId",
  APPROVAL_SETTINGS: "/approval-settings",
  PENDING_APPROVAL: "/pending-approval",
  PRE_ORDER_ITEMS_1: "/pre-order-items",
  ORDERS: "/orders/:orderId",
  QUOTES: "/quotes/:quoteId",
  RESET_PASSWORD: "/reset-password",
  NOTIFICATIONS: "/notifications",
  QUICK_ORDER: "/quick-order",
  PRE_ORDERS_1: "/pre-orders",
  DASHBOARD: "/dashboard",
  SUPPLIERS_1: "/suppliers",
  ADDRESSES: "/addresses",
  CHECKOUT: "/checkout",
  ACTIVITY: "/activity",
  FINANCE: "/finance",
  PROFILE: "/profile",
  CATALOG_1: "/catalog",
  QUOTES_1: "/quotes",
  ORDERS_1: "/orders",
  SIGNUP: "/signup",
  LEDGER: "/ledger",
  LOGIN: "/login",
  TEAM: "/team",
  CART: "/cart",
  RMA: "/rma",
  CONSIGNMENT: "/consignment",
  ROOT: "/",
});
